/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import sass from "./statuses.module.sass";
import { Search } from "components-new";
import { Button } from "components/shared";
import ModalPortal from "components-new/ModalPortal";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import useDebounce from "hooks/useDebounce";
import Badge from "components-new/Badge";
import InputTemp from "components-new/InputTemp";
import { useValidate } from "hooks/useValidate";
import { AxiosError } from "axios";
import { snackWrapper } from "helpers";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../../toolkit/hooks";
import { checkCompletingReferences } from "../../../toolkit/references/references.thunks";
import {directoryAPI} from "../../../libs/apiClient/Directory";
import {userAPI} from "../../../libs/apiClient/User";

const initial: ITypeOwnership = {
	name: "",
};
const errorsRequest = {
	name: "Статус уже существует",
};
const initialErrorsRequest = {
	name: "",
};
const Modal: React.FC<{
	rootFunc: Dispatch<SetStateAction<ITypeOwnership[]>> | Dispatch<SetStateAction<ITypeOwnership[] | null>>;
	trigger: { active: boolean; data: ITypeOwnership | null };
	cancelWindow: () => void;
}> = ({ trigger, rootFunc, cancelWindow }) => {
	const [newType, setNewType] = useState<ITypeOwnership>(initial);
	const dispatch = useAppDispatch();
	useEffect(() => {
		if (trigger.data) {
			setNewType(trigger.data);
		} else {
			setNewType(initial);
		}
	}, [trigger]);
	const [errors, setErrors] = useState(initialErrorsRequest);

	const setError = (arr: Array<keyof typeof errors>) => {
		setErrors(() => {
			let newData: typeof errors = {
				name: "",
			};
			arr.forEach((_) => {
				newData[_] = errorsRequest[_];
			});
			return newData;
		});
	};
	const send = () => {
		if (!trigger.data) {
			directoryAPI.personStatusCreate(newType )
				.then((r) => {
					snackWrapper("success", "Запись успешно создана");
					rootFunc((prevState: any) => [...prevState, r.data]);
					dispatch(checkCompletingReferences());
					cancelWindow();
				})
				.catch((e: AxiosError) => {
					if (e.response && e.response.status === 409 && e.response.data) {
						setError(Array.isArray(e.response.data) ? e.response.data : (e.response.data as string).split(" "));
					}
				});
		} else {
			const { id, ...rest } = newType;
			directoryAPI.personStatusUpdate(id!,rest )
				.then((r) => {
					snackWrapper("success", "Запись успешно отредактирована");
					rootFunc((prevState: any) => [...prevState].map((_) => (_.id === r.data.id ? { ...r.data } : _)));
					dispatch(checkCompletingReferences());
					cancelWindow();
				})
				.catch((e: AxiosError) => {
					if (e.response && e.response.status === 409 && e.response.data) {
						setError(Array.isArray(e.response.data) ? e.response.data : (e.response.data as string).split(" "));
					}
				});
		}
	};

	const { error, validate } = useValidate(newType, ["name"], send);

	const changeField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		let { name, value } = e.target;
		if (/^\s/.test(value)) value = value.replace(/^\s/, "");
		setErrors((prevState) => ({ ...prevState, [name]: "" }));
		setNewType((prevState) => ({ ...prevState, [name]: value }));
	};
	useEffect(() => {
		return () => setErrors(initialErrorsRequest);
	}, [trigger.active]);

	return trigger.active ? (
		<ModalPortal
			outSide={false}
			title={trigger.data ? "Редактировать статус" : "Создать статус"}
			handleClose={cancelWindow}>
			<div className={sass.modal}>
				<InputTemp
					errorText={errors.name}
					onChange={changeField}
					error={error && !newType.name}
					name={"name"}
					value={newType.name}
					placeholder={"Введите текст"}
					label={"Статус"}
					required
				/>
				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button onClick={validate}>Готово</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};

interface ITypeOwnership {
	id?: number;
	name: string;
}

const StatusesEmployee = () => {
	const [data, setData] = useState<ITypeOwnership[]>([]);
	const [filter, setFilter] = useState<ITypeOwnership[] | null>(null);
	const location = useLocation();
	useEffect(() => {
		directoryAPI.personStatusListList().then((r) => setData(r.data));
	}, []);
	const [modal, setModal] = useState<{ active: boolean; data: ITypeOwnership | null }>({
		active: false,
		data: null,
	});

	const [search, setSearch] = useState("");

	const query = useDebounce(search, 400);

	useEffect(() => {
		if (query as string) {
			directoryAPI.personStatusListList({query}).then((r) => setFilter(r.data));
		} else if (query === "") {
			setFilter(null);
		}
	}, [query]);
	const outlineStyle = useCallback(
		(id: number) => {
			return location.state && location.state.outline && location.state.outline === id ? sass.outline : "";
		},
		[location],
	);
	const [disabled, setDisabled] = useState(false);
	const needRule = useCallback(() => {
		if (disabled) snackWrapper("error", "Не достаточно прав");
	}, [disabled]);
	useEffect(() => {
		userAPI.permissionsCheckCreate(0, ["dictionary.person_status.edit"])
			.then((r) => setDisabled(!r.data.length));
	}, []);
	return (
		<div className={sass.wrapper}>
			<Modal
				rootFunc={filter && filter.length ? setFilter : setData}
				trigger={modal}
				cancelWindow={() => setModal((prevState) => ({ ...prevState, active: false }))}
			/>
			<HeadPage title={"Статусы сотрудников"}>
				<div className={sass.head}>
					<Search className={sass.search} searchValue={search} handleSearch={(e) => setSearch(e.target.value)} />
					<Button disabled={disabled} onClick={() => setModal({ active: true, data: null })}>
						Добавить значение
					</Button>
				</div>
			</HeadPage>
			<table>
				<thead>
					<tr>
						<th>Номер</th>
						<th>Статус</th>
					</tr>
				</thead>
			</table>
			<div data-comment-false={true} className={sass.scroll}>
				<table>
					<tbody>
						{filter
							? filter.map((_, index) => (
									<tr
										className={outlineStyle(_.id!)}
										onClick={() => (disabled ? needRule() : setModal({ active: true, data: _ }))}
										key={index}>
										<td>{index + 1}</td>
										<td>
											<Badge type={"info"}>{_.name}</Badge>
										</td>
									</tr>
							  ))
							: data.map((_, index) => (
									<tr
										className={outlineStyle(_.id!)}
										onClick={() => (disabled ? needRule() : setModal({ active: true, data: _ }))}
										key={index}>
										<td>{index + 1}</td>
										<td>
											<Badge type={"info"}>{_.name}</Badge>
										</td>
									</tr>
							  ))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default StatusesEmployee;
